<template>
  <div class="row">
    <div class="col-md-12">
      <div
        class="data-load"
        :class="{
          'sk-loading': showSpinner,
          card: !stickyTable,
          'data-load--scroll-x': stickyTable,
        }"
      >
        <sk-spinner v-if="showSpinner"></sk-spinner>
        <div :class="{ 'card-body': !stickyTable }">
          <div>
            <div class="row">
              <div class="col col-sm-8 col-md-8 col-lg-8">
                <h4 v-if="rows.length > 0">
                  {{ rows.length }} {{ $t("components.table.results") }}
                </h4>
              </div>
              <div class="col col-sm-4 col-md-4 col-lg-4 text-right" v-if="showRefreshButton">
                <a
                  href="#"
                  class="p-2 float-right btn-refresh"
                  @click.prevent="refreshButtonClicked"
                  ><i class="fas fa-sync-alt"></i
                ></a>
              </div>
            </div>
          </div>
          <div :class="stickyTable ? 'table-scroll-x' : 'table-responsive'">
            <table :class="classTable">
              <thead>
                <tr>
                  <th v-if="showRowTableAction" :class="{ sticky_column_action: stickyTable }">
                    &nbsp;
                  </th>

                  <th
                    v-for="(column, column_index) in tableColumns"
                    :key="`${column.id}_${column_index}`"
                    :style="column.styleHeader"
                    :class="addStickyClassHeader(column_index, column.classHeader)"
                  >
                    <span v-if="!column.useTranslate">{{ column.name }}</span>
                    <span v-else>{{ $t(column.name) }}</span>
                  </th>
                </tr>
              </thead>

              <tbody v-if="rows.length > 0">
                <tr
                  v-for="(row, index_row) in rows"
                  :key="`${index_row}_${new Date().getMilliseconds()}`"
                >
                  <td
                    :class="{
                      'td-align-left': true,
                      'text-center': true,
                      'p-1': true,
                      sticky_column_action: stickyTable,
                    }"
                    v-if="showRowTableAction"
                    :style="{ width: '60px !important' }"
                  >
                    <slot name="table-action" :row="row">
                      <div class="dropdown table-action-dropdown">
                        <button
                          class="btn btn-default table-action-btn"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          data-boundary="window"
                          data-display="dynamic"
                          aria-haspopup="true"
                          aria-expanded="false"
                          :aria-label="$t('pages.planing-team.actions')"
                        >
                          <i class="fas fa-ellipsis-v"></i>
                        </button>
                        <div
                          class="dropdown-menu table-action-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <slot name="table-action-menu" :row="row"></slot>
                        </div>
                      </div>
                    </slot>
                  </td>
                  <td
                    v-for="(cell, index_cell) in row.getCells"
                    :key="index_cell"
                    :style="cell.getColumn.styleCell"
                    :class="addStickyClassCell(index_cell, cell.getColumn.classCell)"
                  >
                    <slot name="table-row" :cell="cell" :row="row">
                      <span>{{ cell.getValue }}</span>
                    </slot>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td :colspan="tableColumns.length + 1" class="text-center">
                    {{ emptyRowsMessage }}
                  </td>
                </tr>
              </tbody>
              <tfoot v-if="showFooterTable">
                <tr>
                  <td
                    v-for="(column, column_index) in tableColumns"
                    :key="`${column_index}_${new Date().getMilliseconds()}_foot_column`"
                  >
                    <slot name="table-tfoot-row" :column="column"> </slot>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div class="row">
            <div class="col">
              <slot name="description"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Column, Cell, Row, VUE_DATA_TABLE_NEED_DATA_UPDATE } from "./index";
import SkSpinner from "@/components/SkSpinner";

export default {
  name: "VueDataTable",
  components: {
    SkSpinner,
  },
  props: {
    tableColumns: {
      type: Array,
      validator: function (columns) {
        for (let column of columns) {
          if (!(column instanceof Column)) {
            console.error("tableColumns should include only Column instance");
            return false;
          }
        }
        return true;
      },
      required: true,
    },
    tableRows: {
      type: Array,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    emptyRowsMessage: {
      type: String,
      default: "The table does not contain data",
    },
    showFooterTable: {
      type: Boolean,
      default: true,
    },
    showRowTableAction: {
      type: Boolean,
      default: true,
    },
    showRefreshButton: {
      type: Boolean,
      default: true,
    },
    stickyTable: {
      type: Boolean,
      default: false,
    },
    classTable: {
      default() {
        return ["table", "table-striped"];
      },
    },
  },
  mounted() {
    // // https://stackoverflow.com/questions/76079028/bootstrap-sticky-column-in-table-z-index-issue
    // const observer = new MutationObserver((entries) =>
    //   entries.forEach(({ target }) => {
    //     target.closest(":first-child:is(th, td)").style.zIndex = target.classList.contains("show")
    //       ? "2"
    //       : "";
    //   })
    // );
    // document.querySelectorAll(".dropdown").forEach((dropdown) => {
    //   const thTdFirst = dropdown.closest(":first-child:is(th, td)");
    //   if (thTdFirst) {
    //     observer.observe(dropdown, { attributeFilter: ["class"] });
    //   }
    // });
  },
  data() {
    return {
      /** @param {Array.<Row>} rows */
      rows: [],
      isPreparing: false,
    };
  },
  computed: {
    showSpinner() {
      return this.isLoading || this.isPreparing;
    },
  },
  watch: {
    tableRows: {
      handler() {
        this.onPrepareData();
      },
      immediate: true,
    },
    tableColumns: {
      handler() {
        this.onPrepareData();
      },
    },
  },

  methods: {
    refreshButtonClicked() {
      this.$emit(VUE_DATA_TABLE_NEED_DATA_UPDATE);
    },
    onPrepareData() {
      this.isPreparing = true;

      let data = [];
      for (const row of this.tableRows) {
        let tableRow = new Row({ raw: row });
        /** @param {Column} column */
        for (const column of this.tableColumns) {
          tableRow.addCell(new Cell({ column, value: row }));
        }
        data.push(tableRow);
      }

      this.rows = data;
      this.isPreparing = false;
    },
    addStickyClassCell(index, classes) {
      if (this.stickyTable) {
        if (index == 0) {
          if (Array.isArray(classes)) {
            return [...classes, "sticky_first_column"];
          } else if (classes instanceof Object) {
            return Object.assign(classes, { sticky_first_column: true });
          }
        }
      }
      return classes;
    },
    addStickyClassHeader(index, classes) {
      if (this.stickyTable) {
        if (index == 0) {
          if (Array.isArray(classes)) {
            return [...classes, "sticky_header_first_column"];
          } else if (classes instanceof Object) {
            return Object.assign(classes, { sticky_header_first_column: true });
          }
        } else {
          if (Array.isArray(classes)) {
            return [...classes, "sticky_header_action"];
          } else if (classes instanceof Object) {
            return Object.assign(classes, { sticky_header_action: true });
          }
        }
      }
      return classes;
    },
  },
};
</script>

<style lang="scss">
.btn-default,
.table-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0 !important;
  background-color: var(--portal-surface) !important;
  border: 1px solid var(--portal-border) !important;
  color: var(--portal-text-muted) !important;
  border-radius: 10px !important;
  box-shadow: var(--portal-shadow-sm);
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover,
  &:focus,
  &[aria-expanded="true"] {
    background: var(--portal-primary-soft) !important;
    border-color: transparent !important;
    color: var(--portal-primary) !important;
    box-shadow: var(--portal-shadow);
  }

  &:focus {
    outline: 2px solid var(--portal-ring);
    outline-offset: 2px;
  }
}

.table-action-menu.dropdown-menu,
.dropdown-menu.table-action-menu {
  z-index: 1045 !important;
  min-width: 200px;
  padding: 0.4rem;
  margin-top: 0.35rem !important;
  border: 1px solid var(--portal-border) !important;
  border-radius: 14px !important;
  background: var(--portal-surface) !important;
  box-shadow: var(--portal-shadow) !important;

  .dropdown-item,
  .payroll-action {
    display: flex;
    align-items: center;
    gap: 0.7rem;
    padding: 0.7rem 0.8rem !important;
    border-radius: 10px;
    color: var(--portal-text) !important;
    font-size: 0.88rem;
    font-weight: 600;
    letter-spacing: -0.01em;
    text-decoration: none !important;

    img {
      width: 18px;
      height: 18px;
      object-fit: contain;
    }

    i {
      width: 18px;
      text-align: center;
      color: var(--portal-primary);
      font-size: 0.95rem;
    }

    &:hover,
    &:focus {
      background: var(--portal-primary-soft) !important;
      color: var(--portal-text) !important;
    }
  }
}

.table {
  border-collapse: separate;
  border-spacing: 0;
  color: var(--portal-text);

  & > thead > tr:first-child {
    border-bottom: 1px solid var(--portal-border);
    border-top: none;
  }

  & > thead > tr > th {
    border-bottom: 1px solid var(--portal-border) !important;
    border-top: none !important;
    background: var(--portal-surface-muted);
    color: var(--portal-text-muted);
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    padding: 0.85rem 0.75rem;
  }

  & > thead > tr > th:first-child,
  & > thead > tr > th:last-child {
    border-right: none;
  }

  & > tbody > tr > td {
    border-top: 1px solid var(--portal-border);
    border-right: none;
    padding: 0.85rem 0.75rem;
    vertical-align: middle;
    background: var(--portal-surface);
  }

  & > tbody > tr:hover > td {
    background: var(--portal-card-hover);
  }
}

.table-striped {
  & tbody tr:nth-of-type(#{$table-striped-order}) {
    background-color: transparent !important;

    > td {
      background: var(--portal-surface-muted);
    }
  }
}

.data-load.card {
  border: 1px solid var(--portal-border);
  border-radius: 16px;
  background: var(--portal-surface);
  box-shadow: var(--portal-shadow-sm);
  overflow: hidden;
}

.data-load--scroll-x {
  width: 100%;
  max-width: 100%;
}

.table-scroll-x {
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 0.5rem;

  > table {
    width: max-content;
    min-width: 100%;
    margin-bottom: 0;
  }
}

.btn-refresh {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  color: var(--portal-text-muted) !important;
  transition: background 0.2s ease, color 0.2s ease;

  &:hover {
    background: var(--portal-primary-soft);
    color: var(--portal-primary) !important;
  }
}

.sticky_header_action {
  padding: 3px;
  position: sticky;
  top: 0;
  z-index: 1;
  background: var(--portal-surface-muted);
}

.sticky_header_first_column {
  position: sticky;
  left: 60px !important;
  z-index: 2;
  background: var(--portal-surface-muted);
}

.sticky_column_action {
  position: sticky;
  left: 0;
  z-index: 1;
  overflow: visible;
  background: var(--portal-surface);
}

.sticky_first_column {
  position: sticky;
  left: 60px !important;
  z-index: 2;
  background: var(--portal-surface);
}

.table-action-dropdown.show,
:nth-child(1):is(th, td):has(.dropdown.show),
:nth-child(2):is(th, td):has(.dropdown.show) {
  z-index: 20;
}
</style>
